import asyncLoader from "./asyncLoader";

import Login from "../ui/Login/Login";
import Home from "../ui/Home/Home";
import Rules from "../ui/Rules/Rules/Rules";
import RulesReport from "../ui/Rules/Reports/Reports";
import Import from "../ui/Import/Import";
import Live from "../ui/Live/Live";
import Evidence from "../ui/Evidence/Evidence";
import EvidenceReport from "../ui/Evidence/Report/EvidenceReport";
import Operations from "../ui/Operations/Operations";
import Summary from "../ui/Summary/Summary";
import MasterRules from "../ui/MasterRules/MasterRules";
import ImportStatus from "../ui/ImportOverview/ImportStatus/ImportStatus";

/*
const Login = asyncLoader(() => import("../ui/Login/Login"));
const Home = asyncLoader(() => import("../ui/Home/Home"));
const Rules = asyncLoader(() => import("../ui/Rules/Rules/Rules"));
const RulesReport = asyncLoader(() => import("../ui/Rules/Reports/Reports"));
const Import = asyncLoader(() => import("../ui/Import/Import"));
const Live = asyncLoader(() => import("../ui/Live/Live"));
const Evidence = asyncLoader(() => import("../ui/Evidence/Evidence"));
const EvidenceReport = asyncLoader(() => import("../ui/Evidence/Report/EvidenceReport"));
const Operations = asyncLoader(() => import("../ui/Operations/Operations"));*/

export const ReportRoutes = {
    ruleInstanceId: '/Reports/:ruleInstanceId',
    ruleInstanceId_Date: '/Reports/:ruleInstanceId/:dateRange',
    ruleInstanceId_Index_List: '/Reports/:ruleInstanceId/:index/:list',
    ruleInstanceId_Index_List_Date: '/Reports/:ruleInstanceId/:index/:list/:dateRange'
}

export default [
    {
        path: "/Sites",
        exact: true,
        authorise: true,
        component: Home
    },
    {
        path: "/Operations",
        exact: true,
        authorise: true,
        component: Operations
    },
    {
        path: "/Summary",
        exact: true,
        authorise: true,
        component: Summary
    },
    {
        path: "/Login",
        exact: true,
        authorise: false,
        component: Login
    },
    {
        path: "/Rules/:name",
        exact: true,
        authorise: true,
        component: Rules
    },
    {
        path: ReportRoutes.ruleInstanceId,
        exact: true,
        authorise: true,
        component: RulesReport,
        strict: true
    },
    {
        path: ReportRoutes.ruleInstanceId_Date,
        exact: true,
        authorise: true,
        component: RulesReport
    },
    {
        path: ReportRoutes.ruleInstanceId_Index_List,
        exact: true,
        authorise: true,
        component: RulesReport,
        strict: true
    },
    {
        path: ReportRoutes.ruleInstanceId_Index_List_Date,
        exact: true,
        authorise: true,
        component: RulesReport
    },
    {
        path: "/Live",
        exact: true,
        authorise: true,
        component: Live
    },
    {
        path: "/Live/:isdebug",
        exact: true,
        authorise: true,
        component: Live
    },
    {
        path: "/Import/Spreadsheet",
        exact: true,
        authorise: true,
        component: Import
    },
    {
        path: "/MasterRules",
        exact: false,
        authorise: true,
        component: MasterRules
    },
    {
        path: "/Evidence",
        exact: true,
        authorise: true,
        component: Evidence
    },
    {
        path: "/Evidence/Report/:siteName/:iEnergyViewId/:dataType/:id",
        exact: false,
        authorise: true,
        component: EvidenceReport
    }
];

/**
 * There is a piece of functionality within setupRedux.js that ensures only
 * routes that exist can be navigated to. This doesn't work well at all with
 * nested routes. Therefore, you need to add any potential nested routes here.
 * The main container for the nested routes still needs to be included in the
 * main route array above.
 */
export let nestedRoutes = [
    { path: "/MasterRules/Import" },
    { path: "/MasterRules/Import/Status/:id" },
    { path: "/MasterRules/Import/Status/:id/TagLabels/:label" },
    { path: "/MasterRules/All" },
    { path: "/MasterRules/All/:ruleId/" },
];



// WEBPACK FOOTER //
// ./src/boot/routeConfig.js